import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getEvents } from '../../actions';
import { IIntegrationEvent } from '../../models/installation';
import { RootState } from '../rootReducer';
import { FetchError } from '../../models/errors';

export interface IEventState {
    events: IIntegrationEvent[];
    isFetching: boolean;
    error?: Error;
}

export const initialState: IEventState = {
    events: [],
    isFetching: false,
};

const name = 'event';

const eventSlice = createSlice({
    initialState,
    name,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getEventsAction.pending, (state) => {
                state.isFetching = true;
            })
            .addCase(getEventsAction.fulfilled, (state, { payload }) => {
                state.isFetching = false;
                state.error = undefined;
                state.events = payload;
            })
            .addCase(getEventsAction.rejected, (state, { payload }) => {
                state.isFetching = false;
                state.error = payload;
            });
    },
});

export const getEventsAction = createAsyncThunk<
    IIntegrationEvent[],
    void,
    { state: RootState; rejectValue: FetchError }
>(`${name}/getEvents`, async (_, { getState, rejectWithValue }) => {
    try {
        const state = getState();
        return await getEvents(state.user.user, state.installation.installation);
    } catch (error) {
        if (error instanceof FetchError) {
            // api response errors i.e. 400 and 404
            return rejectWithValue({ name: error.name, message: error.message, code: error.code, body: error.body });
        }
        return rejectWithValue(error);
    }
});

export const eventSelectors = {
    events: (state: RootState) => state.event.events,
    isFetching: (state: RootState) => state.event.isFetching,
    error: (state: RootState) => state.event.error,
};

export default eventSlice.reducer;
